import { AfterViewInit, Directive, ElementRef, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PageScrollService } from 'ngx-page-scroll-core';

@Directive({
    selector: '[setFocus]',
    standalone: false
})

export class SetFocusDirective implements AfterViewInit {

  // flag for directive to be applied or not
  @Input() isApplied: boolean;

  constructor(
    private _elRef: ElementRef,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any
  ) {
  }

  ngAfterViewInit() {
    if (this.isApplied) {
      const currentElement = this._elRef.nativeElement;
      this.pageScroll(currentElement);
      setTimeout(() => currentElement.focus(), 500);
    }
  }

  /**
   * Page scroll to the selected element
   * @param currentElement
   */
  pageScroll(currentElement) {
    this.pageScrollService.scroll({
      document: this.document,
      scrollTarget: currentElement,
      duration: 500,
      scrollOffset: currentElement.getBoundingClientRect().top
    });
  }
}
